import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#updateDeliveryEstimates();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #updateDeliveryEstimates() {
    // Date-only UTC arithmetic prevents DST from shifting displayed dates.
    const today = new Date();
    const start = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
    const addBusinessDays = (count) => {
      const date = new Date(start);
      let remaining = count;
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) remaining -= 1;
      }
      return date;
    };

    this.querySelectorAll('[data-brx-delivery-estimate]').forEach((element) => {
      const min = Number(element.dataset.minDays);
      const max = Number(element.dataset.maxDays);
      if (!Number.isInteger(min) || !Number.isInteger(max) || min < 1 || max < min) return;

      const locale = element.dataset.locale || document.documentElement.lang || 'de';
      const formatter = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
      });
      const from = formatter.format(addBusinessDays(min));
      const to = formatter.format(addBusinessDays(max));
      const label = element.dataset.label || 'Estimated delivery';
      element.textContent = from === to
        ? `${label}: ${from}`
        : `${label}: ${from} – ${to}`;
    });
  }

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newInventory = html.querySelector('product-inventory');
        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });
        this.#updateDeliveryEstimates();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
